export const formatCurrency = (value: number | null | undefined): string => {
  if (!value) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatCostRange = (min?: number, max?: number): string => {
  if (!min && !max) return 'No estimate';
  if (min && max && min !== max) return `${formatCurrency(min)}-${formatCurrency(max)}`;
  return formatCurrency(min || max || 0);
};

export const formatSystemLabel = (key: string): string => {
  const labels: Record<string, string> = {
    structural: 'Structural',
    plumbing: 'Plumbing',
    electrical: 'Electrical',
    hvac: 'HVAC',
    roof: 'Roof',
    interiorElements: 'Interior',
    exteriorElements: 'Exterior',
    safetySystems: 'Safety Systems',
    appliances: 'Appliances',
    miscellaneousSystems: 'Miscellaneous',
  };
  return labels[key] || key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (char) => char.toUpperCase());
};

export const timeframeRank = (timeframe?: string): number => {
  const normalized = (timeframe || '').toLowerCase();
  if (
    normalized.includes('before_close') ||
    normalized.includes('before close') ||
    normalized.includes('closing') ||
    normalized.includes('immediate') ||
    normalized.includes('urgent')
  ) {
    return 0;
  }
  if (normalized.includes('next_month') || normalized.includes('next month') || normalized.includes('30')) return 1;
  if (normalized.includes('after_move') || normalized.includes('after move') || normalized.includes('60') || normalized.includes('90')) return 2;
  return 3;
};
